import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import InstructionHint from '@/components/ui/InstructionHint';
import MultiTextInput from '@/components/ui/MultiTextInput';
import { useStepper } from '@/features/v2/lib/stepper';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const PROVIDED_TO_IC_INVOICES_LIST = 'provided_to_ic_invoices_list';
export const PROVIDED_TO_IC_RECEIPTS_LIST = 'provided_to_ic_receipts_list';
export const PROVIDED_TO_IC_OTHER_DOCUMENTS_LIST =
  'provided_to_ic_other_documents_list';

export const InputDocumentType = ({
  label,
  name,
}: {
  label: string;
  name: string;
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const { innerStep } = useStepper();
  const isRequired = innerStep === 4;

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: isRequired,
          message: i18n.t('Uzupełnij to pole, aby zakończyć formularz'),
        },
      }}
      defaultValue={[]}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <InstructionHint
            title={i18n.t('Napisz coś i zatwierdź, klikając ENTER.')}
          />
          <FormControl>
            <MultiTextInput
              id={name}
              {...field}
              success={!!field.value?.length}
              data-testid="input-document-type"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
